<template>
    <div class="query-form">
        <el-form :inline="true" :model="form" class="form" ref="form">
            <el-form-item label="" class="item-time">
                <el-select v-model="form.timeType" placeholder="请选择">
                    <el-option v-for="(item,index) in tradTime" :key="index" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" class="item-date" prop="datePicker">
                <el-date-picker v-model="startEndTime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-for="item of formList" :key="item.label" :label="item.label" :prop="item.prop">
                <el-select v-model="form[item.prop]" placeholder="请选择">
                    <el-option v-for="el in item.options" :key="el.key" :label="el.key" :value="el.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付渠道">
                <el-select v-model="form.payChannel" placeholder="请选择" @change="payChanneChange">
                    <el-option v-for="item in payChannelList" :key="item.chanCode" :label="item.chanName" :value="item.chanCode"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.payType" placeholder="请选择">
                    <el-option v-for="item in payWayList" :key="item.wayCode" :label="item.wayName" :value="item.wayCode"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="item-type">
                <el-button type="primary" @click="submitForm(form)">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'queryForm',
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  inject: {
    submitForm: 'submit',
    formList: 'formList',
    tradTime: 'tradTime',
    resetForm: 'resetForm',
  },
  data() {
    return {
      checkdApply: {},
      startEndTime: [],
    };
  },
  computed: {
    ...mapState({
      payChannelList: (state) => state.trading.payChannelList,
      payWayList: (state) => state.trading.payWayList,
    }),
  },
  created() {
    this.checkdApply = JSON.parse(localStorage.getItem('checkdApply'));
    this.queryPayChannel({ mchCode: this.checkdApply.applyCode });
  },
  methods: {
    ...mapActions('trading', ['queryPayChannel', 'queryPayWay']),
    handleChange(value) {
      console.log(value);
    },
    payChanneChange(e) {
      this.queryPayWay({ mchCode: this.checkdApply.applyCode, chanCode: e });
    },
    dateChange() {
      this.$emit('dateChange',this.startEndTime)
    },
    clearDate(){
      this.startEndTime=[]
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';

// 重写 element-ui 样式
.el-form-item {
  margin: 0;
}
/deep/.el-form-item__label {
  color: @font-color-black;
}
.el-date-editor .el-range__icon {
  display: none;
}
.el-button--primary {
  .button--primary(@primary-blue);
  margin-right: 20px;
}

// 正常样式
.query-form {
  padding: 20px;
  .reconciliation_list_space(@bg-white);
}
.item-date {
  margin-right: 40px;
  margin-bottom: 20px;
}
.item-type {
  margin-left: 30px;
}
.item-time {
  width: 150px;
  margin-right: 10px;
}
</style>
